// extracted by mini-css-extract-plugin
export default {"container":"style_container__oXdAZ","card":"style_card__zFelB"};